import { ApiService } from './api.service';
import { StatsCharacterMapping } from '@/models/statistics/stats-character-mapping';
import { StatsNetwork } from '@/models/statistics/stats-network';
import { StatsCompetencyBoxplot } from '@/models/statistics/stats-competency-boxplot';
import { StatsRequest } from '@/models/statistics/stats-request';

class StatsService extends ApiService {
  constructor() {
    super();
  }

  getStatsCharacterMapping(targetType: number = 0, targetID: number = 0, tagIDs: string = '', evalSettingID: number = 0): Promise<StatsCharacterMapping> {
    return this.get(StatsCharacterMapping, 'statistics/characterMapping', {
      targetType,
      targetID,
      tagIDs,
      evalSettingID,
    });
  }
  getStatsNetwork(targetType: number = 0, targetID: number = 0, tagIDs: string = '', evalSettingID: number = 0): Promise<StatsNetwork> {
    return this.get(StatsNetwork, 'statistics/network', {
      targetType,
      targetID,
      tagIDs,
      evalSettingID,
    });
  }

  getCompetencyDistribution(targetType: number = 0, targetID: number = 0, tagIDs: string = '', evalSettingID: number = 0): Promise<StatsCompetencyBoxplot[]> {
    return this.getList(StatsCompetencyBoxplot, 'statistics/competencyDistribution', {
      targetType,
      targetID,
      tagIDs,
      evalSettingID,
    });
  }
}

export const statsService = new StatsService();
